export const loaderBoxStyles = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "100%",
  width: "100%",
  position: "fixed",
  top: 0,
  left: 0,
  background: "rgba(255, 255, 255, 0.5)",
  zIndex: 9999,
};
